import Link from 'next/link'
import s from './TopNavLinks.module.css'

const TopLinkNavItems = () => {
  // Links for top nav
  return (
    <>
      <li>
        <Link aria-label="Shipping Information" rel="related" href="/shipping">
          <a>Free Shipping</a>
        </Link>
      </li>
      <li>
        <Link aria-label="Returns policy" rel="related" href="/returns">
          <a>30 day returns</a>
        </Link>
      </li>
      <li>
        <Link
          aria-label="Lifetime Upgrades"
          rel="related"
          href="/info/guarantee#lifetime-upgrades"
        >
          <a>Lifetime Upgrades</a>
        </Link>
      </li>
      <li className="md:hidden">
        <Link href="/blog">
          <a aria-label="Yadav Jewelry and Diamond News" rel="related">
            Blog
          </a>
        </Link>
      </li>
    </>
  )
}

const TopNavLinks = () => {
  return (
    <nav>
      <ul className={s.topNavList}>
        <TopLinkNavItems />
      </ul>
    </nav>
  )
}

export default TopNavLinks
